export const GET_BETA_STATION= 'GET_BETA_STATION';
export const GET_BETA_STATION_SUCCESS = 'GET_BETA_STATION_SUCCESS';
export const SET_BETA_BANNER_CLOSED = 'SET_BETA_BANNER_CLOSED';

